(ns teamoesterreich.admin-mode.event.detail.event-history
  (:require [clojure.string]
            [goog.string.format]
            [teamoesterreich.view-state :as store]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.logs :as d-logs]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            ))



(defn get-it []
  (let [!st (r/atom {:logs nil :loaded false :tomId 0})
        !event (r/cursor store/app-state [:selected-event])
        !event-uuid (r/cursor !st [:event-uuid])
        !logs (r/cursor !st [:logs])
        !loaded (r/cursor !st [:loaded])]

    (fn []
      (let [event-uuid (:crowdtaskerEvent-uuid @!event)]
        [:div
         [:h3 "Einsatz Verlauf-Dokumentation"]

         (log/debug "Logs " (not (true? @!loaded)) (not= @!event-uuid event-uuid) (clj->js @!logs))
         (if (or (not (true? @!loaded)) (not= @!event-uuid event-uuid))
           ;not loaded
           (do
             (d-logs/<get-event-log-list event-uuid
                                         (fn [data] (swap! !st assoc
                                                           :logs data
                                                           :loaded true
                                                           :event-uuid event-uuid)))
             [mui/card {:style {:textAlign "left" :marginTop "10px"}}
              [mui/card-header
               {:title (str "Lade den Verlauf für: `" (:crowdtaskerEvent-name @!event) "`")}]
              ])

           ;is loaded
           [mui/card {:style {:textAlign "left" :marginTop "10px"}}
            [ws-event-sync-component/ws-event-reload !loaded :event event-uuid]

            [mui/card-content
             [mui/table
              [mui/table-head
               [mui/table-row
                [mui/table-cell "Datum"]
                [mui/table-cell "Bearbeiter"]
                [mui/table-cell "Teilnehmer"]
                [mui/table-cell "Beschreibung"]
                ]]

              [mui/table-body
               (for [[uuid entry] (reverse (sort-by (fn [[k v]] (:log-date v))
                                                    (filter (fn [[k v]] (not= (str (:log-message v)) "")) @!logs)))]
                 ^{:key (str "log-" uuid)}
                 [mui/table-row
                  [mui/table-cell (h/date-time-ger-fromT (:log-date entry))]
                  [mui/table-cell (str (get-in entry [:log-admin :user-firstName]) " " (get-in entry [:log-admin :user-lastName]))]
                  [mui/table-cell (str (get-in entry [:log-user :user-firstName]) " " (get-in entry [:log-user :user-lastName]))]
                  [mui/table-cell [:pre (:log-message entry)]]
                  ])
               ]
              ]
             ]
            ])
         ]
        )
      )))
















